/* Land Media · Deliverables tabs (sections/lm-deliverables.liquid)
   Accessible tablist, auto-advance with progress bar (pauses on hover / keyboard focus / off-screen),
   panels stacked in one grid cell and toggled with inert so the layout never jumps. */
(function () {
  if (window.__lmDelivLoaded) return;
  window.__lmDelivLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isFocusVisible(el) {
    try { return !!(el && el.matches && el.matches(':focus-visible')); } catch (e) { return false; }
  }

  function setup(sec) {
    if (!sec || sec.__lmDeliv) return;
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('.lm-deliv__tab'));
    var panels = Array.prototype.slice.call(sec.querySelectorAll('.lm-deliv__panel'));
    if (!tabs.length || tabs.length !== panels.length) return;
    sec.__lmDeliv = true;

    var list = sec.querySelector('.lm-deliv__tabs');
    var ui = sec.querySelector('.lm-deliv__ui') || sec;
    var toggle = sec.querySelector('[data-deliv-toggle]');
    var delay = (parseFloat(sec.getAttribute('data-autoplay')) || 0) * 1000;
    var auto = delay > 0 && !reduce && tabs.length > 1;
    var current = 0;
    tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') current = i; });

    var visible = false, seen = false, hovering = false, focused = false, userPaused = false;
    var elapsed = 0, last = 0, raf = 0;

    if (!reduce) sec.classList.add('is-anim');
    if (auto) sec.classList.add('is-auto');
    // Panels wait for the section to scroll into view before animating in.
    if (!reduce) panels.forEach(function (p) { p.classList.remove('is-live'); });

    function play(panel) {
      panel.classList.remove('is-live');
      void panel.offsetWidth;
      panel.classList.add('is-live');
    }
    function centerTab(tab) {
      if (list.scrollWidth <= list.clientWidth + 1) return;
      var left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
      try { list.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = left; }
    }
    var dots = Array.prototype.slice.call(sec.querySelectorAll('.lm-deliv__dots-nav span'));
    function select(i, focus, dir) {
      current = i;
      elapsed = 0;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      panels.forEach(function (p) { p.classList.remove('is-swipe-next', 'is-swipe-prev'); });
      if (dir && !reduce) panels[i].classList.add(dir > 0 ? 'is-swipe-next' : 'is-swipe-prev');
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.style.setProperty('--p', 0);
      });
      panels.forEach(function (p, k) {
        var off = k !== i;
        if (off) {
          p.setAttribute('inert', '');
          p.setAttribute('aria-hidden', 'true');
          p.classList.remove('is-live');
        } else {
          p.removeAttribute('inert');
          p.removeAttribute('aria-hidden');
        }
      });
      if (seen || reduce) play(panels[i]);
      if (focus) tabs[i].focus();
      centerTab(tabs[i]);
    }

    function paused() { return hovering || focused || userPaused || !visible || document.hidden; }
    function frame(now) {
      raf = 0;
      if (!auto || !visible) return;
      var dt = last ? Math.min(now - last, 100) : 0;
      last = now;
      var p = paused();
      sec.classList.toggle('is-paused', p);
      if (!p) {
        elapsed += dt;
        if (elapsed >= delay) select((current + 1) % tabs.length, false);
        else tabs[current].style.setProperty('--p', (elapsed / delay).toFixed(4));
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (auto && !raf) { last = 0; raf = requestAnimationFrame(frame); } }
    function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { if (i !== current) select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, to = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        select(to, true);
      });
    });

    // Touch: swipe the panel sideways to move between phases (vertical scrolling is left alone).
    var stage = sec.querySelector('.lm-deliv__stage');
    if (stage && tabs.length > 1) {
      var sx = 0, sy = 0, st = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now();
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.4 || Date.now() - st > 800) return;
        var dir = dx < 0 ? 1 : -1;
        var to = (current + dir + tabs.length) % tabs.length;
        userPaused = true;
        if (toggle) { toggle.setAttribute('aria-pressed', 'true'); toggle.setAttribute('aria-label', 'Play auto-play'); }
        select(to, false, dir);
      }, { passive: true });
      stage.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }

    ui.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
    ui.addEventListener('pointerleave', function () { hovering = false; });
    // Pause only for keyboard focus. A mouse click also focuses the button in Chrome,
    // which would otherwise freeze auto-play until the visitor clicks elsewhere.
    ui.addEventListener('focusin', function (e) { focused = e.target !== toggle && isFocusVisible(e.target); });
    ui.addEventListener('focusout', function (e) { if (!ui.contains(e.relatedTarget)) focused = false; });

    if (toggle) {
      if (!auto) toggle.hidden = true;
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        focused = false;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', userPaused ? 'Play auto-play' : 'Pause auto-play');
      });
    }

    function onSeen(v) {
      visible = v;
      if (v && !seen) { seen = true; play(panels[current]); }
      if (v) start(); else stop();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { onSeen(en.isIntersecting); });
      }, { threshold: 0.25 }).observe(ui);
    } else {
      onSeen(true);
    }

    sec.__lmDelivSelect = function (i) {
      userPaused = true;
      if (toggle) { toggle.setAttribute('aria-pressed', 'true'); toggle.setAttribute('aria-label', 'Play auto-play'); }
      seen = true;
      select(i, false);
    };
  }

  function init(root) {
    root = root || document;
    if (root.matches && root.matches('[data-lm-deliv]')) setup(root);
    root.querySelectorAll('[data-lm-deliv]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('.lm-deliv__panel');
    if (!panel) return;
    var sec = panel.closest('[data-lm-deliv]');
    if (!sec || !sec.__lmDelivSelect) return;
    var i = Array.prototype.indexOf.call(sec.querySelectorAll('.lm-deliv__panel'), panel);
    if (i > -1) sec.__lmDelivSelect(i);
  });
})();
